/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProfileResponse } from './';
import {
    ProfileResponseFromJSON,
    ProfileResponseFromJSONTyped,
    ProfileResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProfilesCatalog
 */
export interface ProfilesCatalog {
    /**
     * 
     * @type {string}
     * @memberof ProfilesCatalog
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesCatalog
     */
    shortPrompt: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesCatalog
     */
    longPrompt: string;
    /**
     * 
     * @type {Array<ProfileResponse>}
     * @memberof ProfilesCatalog
     */
    profiles: Array<ProfileResponse>;
}

/**
 * Check if a given object implements the ProfilesCatalog interface.
 */
export function instanceOfProfilesCatalog(value: object): value is ProfilesCatalog {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('shortPrompt' in value) || value['shortPrompt'] === undefined) return false;
    if (!('longPrompt' in value) || value['longPrompt'] === undefined) return false;
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    return true;
}

export function ProfilesCatalogFromJSON(json: any): ProfilesCatalog {
    return ProfilesCatalogFromJSONTyped(json, false);
}

export function ProfilesCatalogFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfilesCatalog {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'shortPrompt': json['shortPrompt'],
        'longPrompt': json['longPrompt'],
        'profiles': ((json['profiles'] as Array<any>).map(ProfileResponseFromJSON)),
    };
}

export function ProfilesCatalogToJSON(value?: ProfilesCatalog | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'shortPrompt': value['shortPrompt'],
        'longPrompt': value['longPrompt'],
        'profiles': ((value['profiles'] as Array<any>).map((v) => ProfileResponseToJSON(v))),
    };
}

